import request from "@/router/axios"

export const editDept = (data) => {
    return request({
        url: `/api/basis/dept/info/edit`,
        method: 'post',
        data: data
    })
}
export const list = () => {
    return request({
        url: `/api/basis/dept/info/list`,
        method: 'post',
        data: {
            orderBy: "id",
            isDesc: false
        }
    })
}

export const syncDept = () => {
    return request({
        url: `/api/basis/task/syncDept`,
        method: 'post',
        timeout: 300000
    })
}
